@if (saveSpaceForData$ | async) {
    <div [style.min-height]="instagramHeight">
        <ng-container [csGamingStoriesModuleLoad]="'InstagramSourceComponent'" [data]="data" [config]="config"> </ng-container>
    </div>
}
